import * as React from 'react';
import { Box } from '@mui/material';
import BasicModal from '@components/BasicModal';

interface ExternshipRenewVerificationModalProps {
  open: boolean;
  disabled?: boolean;
  confirm: () => void;
  reject: () => void;
}

const ExternshipRenewVerificationModal: React.FC<ExternshipRenewVerificationModalProps> = ({
  open,
  disabled,
  confirm,
  reject,
}) => {
  return (
    <BasicModal
      open={open}
      primaryAction={{
        label: 'Yes',
        disabled,
        action: confirm,
      }}
      secondaryAction={{
        label: 'No',
        disabled,
        action: reject,
      }}
      maxWidth="sm"
    >
      <Box>
        Site details must be re-verified prior to renewing for a future externship.
      </Box>
      <Box marginTop={'1em'}>
        Have you re-verified the site?
      </Box>
    </BasicModal>
  );
};

export default ExternshipRenewVerificationModal;
